import React, { useState } from "react";
import "./BookingList.css";
import QuoteModal from "../Modals/QuoteModal";
import { PopupModal } from "../PopupModal/PopupModal";
const BookingList = ({ bookings = [], onCardClick }) => {
  const [showQuote, setShowQuote] = useState(false);
  const [selectedBooking, setSelectedBooking] = useState(null);
  const [popupType, setPopupType] = useState("");
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");
  const formatDate = (isoDate) => {
    if (!isoDate) return "";
    return new Date(isoDate).toLocaleDateString("en-IN", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    });
  };

  if (!bookings.length) {
    return <p className="no-bookings">No bookings found</p>;
  }
  const leadId = selectedBooking?.id;
  return (
    <>
      <div className="booking-list">
        {bookings.map((item, index) => {
          const status = item?.lead?.lead_status_name?.toLowerCase();
          const quoteGenerated = status === "quoted";

          return (
            <div
              key={item?.lead?.lead_id || index}
              className="booking-row-wrapper"
            >
              <div
                className={`booking-row ${
                  onCardClick ? "clickable" : "static"
                }`}
                onClick={
                  !quoteGenerated && onCardClick
                    ? () => onCardClick(item)
                    : undefined
                }
              >
                <div className="booking-left">
                  <div className="booking-avatar">
                    <img src={item?.image} alt={item?.service_name} />
                  </div>

                  <div className="booking-info">
                    <h4>{item?.service_name}</h4>
                    <p className="booking-id">#{item?.lead?.lead_id}</p>
                    <small>
                      {item?.lead?.time} |{" "}
                      {formatDate(item?.lead?.created_date)}
                    </small>
                  </div>
                </div>

                <div className="booking-center">
                  <label>Full Name</label>
                  <input type="text" value={item?.lead?.name || ""} readOnly />
                </div>

                <div className="booking-right">
                  <span
                    className={`status-pill ${status.replace(/\s+/g, "-")}`}
                  >
                    {item?.lead?.lead_status_name || "New"}
                  </span>
                </div>
              </div>
              {quoteGenerated && (
                <div className="quote-overlay">
                  <button
                    className="quote-btn"
                    onClick={() => {
                      setSelectedBooking(item);
                      setShowQuote(true);
                    }}
                  >
                    Quote Generated
                  </button>
                </div>
              )}
            </div>
          );
        })}
      </div>
      {showQuote && (
        <QuoteModal
          booking={selectedBooking}
          onClose={() => setShowQuote(false)}
          onSuccess={() => {
            setPopupType("success");
            setMessage("Quote accepted successfully!");
          }}
        />
      )}
      {popupType && (
        <PopupModal
          popupType={popupType}
          setpopupType={setPopupType}
          Message={message}
          error={error}
          Navigation={
            popupType === "success" && leadId
              ? `/patient-dashboard/bookings/${leadId}`
              : ""
          }
          setMessage={setMessage}
        />
      )}
    </>
  );
};

export default BookingList;
